import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=555213de&scoped=true"
import script from "./FormCategory.vue?vue&type=script&lang=js"
export * from "./FormCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555213de",
  null
  
)

export default component.exports